// 위성통신 페이지 데이터. 출처: 회사소개자료(국문) "주요 시스템 설치 및 커미셔닝", HMM 제안서 "유사 사업 수행 실적"
import type { Lang } from "@/lib/useLang";

export const SATELLITE: Record<
  Lang,
  {
    eyebrow: string;
    title: string;
    desc: string;
    seoTitle: string;
    seoDescription: string;
    systemsTitle: string;
    systems: { icon: string; title: string; desc: string }[];
    serviceTitle: string;
    services: { icon: string; title: string; desc: string }[];
    processTitle: string;
    process: { title: string; desc: string }[];
    recordTitle: string;
    records: string[];
    emailTitle: string;
    emailDesc: string;
    relatedTitle: string;
  }
> = {
  ko: {
    eyebrow: "SATELLITE COMMUNICATION",
    title: "항해 중에도 끊김 없는 선박 위성통신",
    desc: "선박 VSAT, FBB, IRIDIUM, 선박 스타링크(STARLINK Maritime), LTE 등 다양한 위성 · 이동통신 시스템을 선박 환경에 맞춰 설치 · 커미셔닝하고, 운항 중 발생하는 통신 장애에 1차 대응합니다.",
    seoTitle: "선박 스타링크 · 위성통신 VSAT 커미셔닝",
    seoDescription: "선박 위성통신 전문 오션커넥트. 선박 VSAT, FBB, IRIDIUM, 선박 스타링크(스타링크 마리타임), LTE 커미셔닝과 선내 네트워크 연동, 운항 중 통신 장애 1차 대응, 선박 이메일 솔루션.",
    systemsTitle: "취급 통신 시스템",
    systems: [
      { icon: "ri-radar-line", title: "VSAT", desc: "고대역폭 위성통신. 선박 VSAT은 업무 데이터, 이메일, 원격 지원의 기본 회선으로 운용합니다." },
      { icon: "ri-global-line", title: "FBB (Fleet Broadband)", desc: "Inmarsat 기반 음성 · 데이터 통신. VSAT 백업 및 소용량 데이터 회선으로 활용합니다." },
      { icon: "ri-signal-tower-line", title: "IRIDIUM", desc: "극지방을 포함한 전 해역을 커버하는 저궤도 위성 통신 단말." },
      { icon: "ri-star-line", title: "STARLINK Maritime (스타링크 마리타임)", desc: "저궤도 위성 기반 고속 인터넷. 선박 스타링크는 선원 복지와 대용량 데이터 통신에 적합하며, 방화벽을 거쳐 선내 네트워크에 연동합니다." },
      { icon: "ri-base-station-line", title: "LTE", desc: "연안 · 항만 구역에서 사용하는 육상 이동통신 회선. 선내 LTE 라우터 설치 및 연동." },
      { icon: "ri-alarm-warning-line", title: "CITADEL 비상통신", desc: "주 통신과 독립된 비상 위성통신. 해적 공격 · 전원 마비 시 최후의 통신 수단." },
    ],
    serviceTitle: "선박 위성통신 서비스 범위",
    services: [
      { icon: "ri-install-line", title: "설치 · 커미셔닝", desc: "안테나 · 단말 설치, 통신 시험, 선내 네트워크 연동 및 방화벽 정책 설정까지 수행합니다." },
      { icon: "ri-customer-service-2-line", title: "장애 1차 대응", desc: "FBB · IRIDIUM · VSAT 통신 장애를 24/365 헬프데스크에서 접수하고 원격 진단 · 조치합니다." },
      { icon: "ri-git-merge-line", title: "통신망 통합 설계", desc: "VSAT · IRIDIUM · STARLINK · LTE 등 여러 회선을 동시에 연결해 선내 네트워크에 통합하고, 회선별 트래픽 정책과 우선순위에 따른 페일오버 및 위성 자동 절체를 설계합니다." },
      { icon: "ri-mail-send-line", title: "선박 이메일 운영", desc: "E-Mail Sharing S/W 공급 · 라이선스 · 운영 지원으로 위성 통신 비용을 절감합니다." },
    ],
    processTitle: "커미셔닝 프로세스",
    process: [
      { title: "사전 조사", desc: "선박 구조, 기존 장비, 회선 현황 파악 및 설치 위치 · 케이블 경로 설계" },
      { title: "설치", desc: "안테나 · 모뎀 · 라우터 설치, 케이블링 및 전원 연결" },
      { title: "통신 시험", desc: "위성 포착, 회선 품질 측정, 음성 · 데이터 통신 테스트" },
      { title: "네트워크 연동", desc: "선내 방화벽 · 스위치 연동, 회선별 접근 정책 및 백업 회선 설정" },
      { title: "교육 · 인계", desc: "선원 대상 사용 교육, 단계별 가이드 제공, 커미셔닝 보고서 제출" },
    ],
    recordTitle: "주요 실적",
    records: [
      "KDDI 관리선박 VSAT 위성통신 시스템 커미셔닝 (2022~)",
      "중대형 선사 대상 VSAT · STARLINK 위성통신 커미셔닝 다수 수행 (2022~2025)",
      "PAN OCEAN 사선 전선대 E-Mail Sharing Solutions 공급 및 설치 (2020)",
      "KDDI 계약선박 MAIL 솔루션 변경 지원 (2022)",
    ],
    emailTitle: "선박 이메일 · 통신 비용 절감",
    emailDesc: "E-Mail Sharing S/W를 공급 · 운영하여 선박과 육상 간 이메일을 효율적으로 동기화하고, 백신 · 보안 패치는 선내 서버에서 일괄 배포하여 위성 통신 데이터 사용량을 줄입니다.",
    relatedTitle: "관련 솔루션",
  },
  en: {
    eyebrow: "SATELLITE COMMUNICATION",
    title: "Uninterrupted vessel communication at sea",
    desc: "Reliable vessel connectivity from port to open sea: we install and commission vessel VSAT, FBB, IRIDIUM, Starlink Maritime, LTE, and other satellite and mobile systems for the onboard environment, and provide first-line response to communication faults during voyages.",
    seoTitle: "Maritime VSAT & Starlink Maritime Commissioning for Vessels",
    seoDescription: "Vessel connectivity and satellite communication by Ocean Connect: commissioning of maritime VSAT, FBB, IRIDIUM, Starlink Maritime and LTE, onboard network integration, first-line fault response at sea, and vessel email solutions.",
    systemsTitle: "Systems We Handle",
    systems: [
      { icon: "ri-radar-line", title: "VSAT", desc: "Maritime VSAT: a high-bandwidth satellite link used as the primary line for business data, email, and remote support." },
      { icon: "ri-global-line", title: "FBB (Fleet Broadband)", desc: "Inmarsat-based voice and data — a VSAT backup and low-volume data line." },
      { icon: "ri-signal-tower-line", title: "IRIDIUM", desc: "Low-earth-orbit terminals covering all sea areas including polar regions." },
      { icon: "ri-star-line", title: "STARLINK Maritime", desc: "LEO-based high-speed internet suited to crew welfare and high-volume data." },
      { icon: "ri-base-station-line", title: "LTE", desc: "Terrestrial mobile line for coastal and port areas; onboard LTE router installation and integration." },
      { icon: "ri-alarm-warning-line", title: "CITADEL Emergency Comm", desc: "Independent emergency satellite link — the last line of contact during piracy or power loss." },
    ],
    serviceTitle: "Vessel Satellite Communication Services",
    services: [
      { icon: "ri-install-line", title: "Installation & Commissioning", desc: "Ship VSAT installation (VSAT terminal and antenna for vessels) and Starlink terminal setup, communication tests, onboard network integration, and firewall policy setup." },
      { icon: "ri-customer-service-2-line", title: "First-line Fault Response", desc: "FBB, IRIDIUM, and maritime VSAT faults are received by our 24/365 helpdesk and diagnosed and fixed remotely." },
      { icon: "ri-git-merge-line", title: "Integrated Link Design", desc: "VSAT, IRIDIUM, STARLINK, LTE and other links connected at the same time and integrated into the onboard network, with per-link traffic policies, priority-based failover and automatic satellite switching." },
      { icon: "ri-mail-send-line", title: "Vessel Email Operation", desc: "E-Mail Sharing S/W supply, licensing, and operation support to cut satellite costs." },
    ],
    processTitle: "Commissioning Process",
    process: [
      { title: "Survey", desc: "Vessel structure, existing equipment, and link status; mounting location and cable route design" },
      { title: "Installation", desc: "Antenna, modem, and router installation, cabling, and power" },
      { title: "Communication Test", desc: "Satellite acquisition, link quality measurement, voice and data tests" },
      { title: "Network Integration", desc: "Onboard firewall and switch integration, per-link access policies, backup link setup" },
      { title: "Training & Handover", desc: "Crew training, step-by-step guides, commissioning report" },
    ],
    recordTitle: "Track Record",
    records: [
      "VSAT commissioning for KDDI managed vessels (2022–)",
      "Numerous VSAT · STARLINK commissioning jobs for mid-to-large shipping companies (2022–2025)",
      "E-Mail Sharing Solutions supplied and installed across the entire PAN OCEAN owned fleet (2020)",
      "Mail solution migration support for KDDI contracted vessels (2022)",
    ],
    emailTitle: "Vessel Email & Cost Savings",
    emailDesc: "We supply and operate E-Mail Sharing S/W to synchronize ship-shore email efficiently, and distribute antivirus and security patches from an onboard server to reduce satellite data usage.",
    relatedTitle: "Related Solutions",
  },
};
